import React, { Component } from "react";
import { connect } from "react-redux";
import SortIcon from "components/sort-icon";

const SORT_FIELD_TEAM = "team";
const SORT_FIELD_POINTS = "points";
const SORT_DIRECTION_ASCENDING = "ascending";
const SORT_DIRECTION_DESCENDING = "descending";

const DEFAULT_ROW_HEADINGS = {
  rank: true,
  team: true,
  points: true,
};

class StandingsTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sortField: SORT_FIELD_POINTS,
      sortDirection: SORT_DIRECTION_DESCENDING,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.type !== prevProps.type) {
      this.setState({
        sortField: SORT_FIELD_POINTS,
        sortDirection: SORT_DIRECTION_DESCENDING,
      });
    }
  }

  sortableHeadingClicked = (field) => {
    const { sortField, sortDirection } = this.state;
    let _sortDirection;

    if (sortField !== field) {
      // just use the existing direction if they are changing fields
      _sortDirection = sortDirection;
    } else {
      // and if its the same field, just toggle direction
      _sortDirection =
        sortDirection === SORT_DIRECTION_ASCENDING
          ? SORT_DIRECTION_DESCENDING
          : SORT_DIRECTION_ASCENDING;
    }

    this.setState({
      sortField: field,
      sortDirection: _sortDirection,
    });
  };

  render() {
    const { teams, type } = this.props;
    const { sortField, sortDirection } = this.state;
    const typeUpper = type.toUpperCase();

    // rewrite rank field
    let sortedTeams = teams
      .sort(
        (a, b) => b.points[typeUpper] - a.points[typeUpper] || a.rank - b.rank
      )
      .map((t, i) => {
        t.rank = i + 1;
        return true;
      });

    if (sortField === SORT_FIELD_TEAM) {
      sortedTeams = teams.sort((a, b) => {
        if (sortDirection === SORT_DIRECTION_ASCENDING) {
          if (a.name.toLowerCase() > b.name.toLowerCase()) return -1;
          if (a.name.toLowerCase() < b.name.toLowerCase()) return 1;
        } else {
          if (b.name.toLowerCase() > a.name.toLowerCase()) return -1;
          if (b.name.toLowerCase() < a.name.toLowerCase()) return 1;
        }
        return 0;
      });
    } else if (sortField === SORT_FIELD_POINTS) {
      sortedTeams = teams.sort((a, b) => {
        // hack to put divine above rapid in s24 twld standings
        if (type === "twld") {
          if (a.name.toLowerCase() === "divine") {
            a.rank = 5;
          } else if (a.name.toLowerCase() === "rapid") {
            a.rank = 6;
          }
        }
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.points[typeUpper] - b.points[typeUpper] || b.rank - a.rank
          : b.points[typeUpper] - a.points[typeUpper] || a.rank - b.rank;
      });
    }

    return (
      <div className="standings-table">
        {
          <StandingsHeader
            {...DEFAULT_ROW_HEADINGS}
            week={1}
            sortField={sortField}
            sortDirection={sortDirection}
            sortFn={this.sortableHeadingClicked}
            type={type}
          />
        }
        {sortedTeams.map((team, i) => {
          return (
            <StandingsRow
              week={1}
              key={team.fnTeamID}
              rank={team.rank}
              img={team.imgUrl}
              team={team.name}
              points={team.points[type.toUpperCase()].toString()}
              sortField={sortField}
              sortDirection={sortDirection}
            />
          );
        })}
      </div>
    );
  }
}

const StandingsHeader = ({ sortField, sortDirection, sortFn, type }) => (
  <div>
    <h2 className={`standings-table-header-type ${type}`}>{type}</h2>
    <div className="standings-table--header">
      <div className="standings-table--header--rank col-rank">
        <span>#</span>
      </div>
      <div className="standings-table--header--team col-team">
        <span>Team</span>
      </div>
      <div className={`standings-table--header--points col-points ${type}`}>
        <div
          className="standings-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_POINTS);
          }}
        >
          <span>P</span>
          {sortField === SORT_FIELD_POINTS ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </div>
    </div>
  </div>
);

const StandingsRow = ({ rank, img, team, points }) => (
  <div className="standings-table--row">
    <div className="standings-table--row--rank col-rank">{rank}</div>
    <div className="standings-table--row--team col-team">
      <div className="standings-table--row--team--image">
        <img src={img} alt={team} width="45" height="45" />
      </div>
      <div className="standings-table--row--team--name">{team}</div>
    </div>
    <div className="standings-table--row--points col-points">{points}</div>
  </div>
);

const mapStateToProps = (state) => ({
  app: state.app,
});

export default connect(mapStateToProps)(StandingsTable);



// WEBPACK FOOTER //
// ./src/components/standings-table/standings-table.js